import React from 'react';
import { formatIBAN } from "../../utils/IBANUtils";
import Amount from '../Amount/Amount';
import RadioInput from '../RadioInput/RadioInput';

const BILHoldersAccounts = ({accounts, confirmationButtonID, radioInputID}) => {

   return (
      <div>
      <div className="BILHoldersAccounts-selection-list">
         {
            Object.keys(accounts).map((key, index) => {
               return(
                  <div key={index}>
                     <div className="BILHoldersAccounts-selection-item" onClick={(e) => onClick(e, confirmationButtonID, radioInputID)}>
                        <RadioInput name={radioInputID} value={accounts[key].iban} />
                        <div className="BILHoldersAccounts-selection-item__container">
                           <div className="BILHoldersAccounts-selection-item__label">{accounts[key].label}</div>
                           <div className="BILHoldersAccounts-selection-item__iban">{formatIBAN(accounts[key].iban)} </div>
                        </div>
                        <Amount balance={accounts[key].balance} currency={accounts[key].currency} />
                     </div>
                     {Object.keys(accounts).length > index + 1 ? <hr className="BILHoldersAccounts-selection-list__separator" /> : null}
                  </div>)
            })
         }
      </div>
   </div>
)}

function onClick (evt, confirmationButtonID, radioInputID) {
   if (evt.dispatchConfig.phasedRegistrationNames.captured === "onClickCapture") {
      var eCurrentTarget = evt.currentTarget.querySelector('input[name=' + radioInputID + ']')
      eCurrentTarget.checked = true
   
      var BILConfirmationButton = document.getElementById(confirmationButtonID)
      BILConfirmationButton.style.pointerEvents = 'auto'
      BILConfirmationButton.style.opacity = '1'
   
      document.querySelectorAll('input[name=' + radioInputID + ']:checked').forEach(x => {
         if (x !== eCurrentTarget) {
            x.checked = false
         }
      })
   }
}

export default BILHoldersAccounts

